/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import OptionsScreen from '../../../Accounts/modals/SendCryptoModal/OptionsScreen';
import { SendCryptoScreensFlow } from '../../../Accounts/constants';
import LedgerWalletsWhitelist from '../../../Accounts/modals/SendCryptoModal/LedgerWalletsWhitelist';
import WhitelistVerify from '../../../Accounts/modals/SendCryptoModal/WhitelistVerify';
import WhitelistSelectAddress from '../../../Accounts/modals/SendCryptoModal/WhitelistSelectAddress';
import WhitelistManageAddresses from '../../../Accounts/modals/SendCryptoModal/WhitelistManageAddresses';
import WhitelistDeleteAddress from '../../../Accounts/modals/SendCryptoModal/WhitelistDeleteAddress';
import WhitelistChangeLedgerWallet from '../../../Accounts/modals/SendCryptoModal/WhitelistChangeLedgerWallet';
import WhitelistAddExternal from '../../../Accounts/modals/SendCryptoModal/WhitelistAddExternal';

const WhitelistManagementModal = ({
  hide,
  wallet,
  wallets,
  onChangeWallet = () => {},
  ledgerAccount = null,
}) => {
  const initialScreen = SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES;
  const { t: translate } = useTranslation();
  const [currentScreen, setCurrentScreen] = useState(
    SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES
  );
  const [currentOptions, setCurrentOptions] = useState({
    [initialScreen]: { wallet, ledgerAccount },
  });

  const sendCryptoFlow = useMemo(
    () => [
      {
        screen: SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE,
        component: (
          <OptionsScreen
            wallet={wallet}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE]}
            types={[
              {
                title: translate('whitelist_add_address_ledger').replace(
                  '%s',
                  wallet?.coin.toUpperCase()
                ),
                onClick: () => {
                  setCurrentScreen(SendCryptoScreensFlow.WHITELIST_WALLET_ADDRESS_LEDGER);
                },
              },
              {
                title: translate('whitelist_add_address_external').replace(
                  '%s',
                  wallet?.coin.toUpperCase()
                ),
                onClick: () => {
                  setCurrentScreen(SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL);
                  setCurrentOptions({
                    ...currentOptions,
                    [SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL]: {
                      prevScreen: SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE,
                    },
                  });
                },
              },
            ]}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_WALLET_ADDRESS_LEDGER,
        component: (
          <LedgerWalletsWhitelist
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            wallet={wallet}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_VERIFY,
        component: (
          <WhitelistVerify
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            wallet={wallet}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_VERIFY]}
            isSendCryptoModal={false}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_SELECT_ADDRESS,
        component: (
          <WhitelistSelectAddress
            wallet={wallet}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_SELECT_ADDRESS]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES,
        component: (
          <WhitelistManageAddresses
            wallet={wallet}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            isSendCryptoModal={false}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_DELETE_ADDRESS,
        component: (
          <WhitelistDeleteAddress
            wallet={wallet}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_DELETE_ADDRESS]}
            isSendCryptoModal={false}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_CHANGE_WALLET,
        component: (
          <WhitelistChangeLedgerWallet
            wallet={wallet}
            wallets={wallets}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_CHANGE_WALLET]}
            onChangeWallet={onChangeWallet}
            isSendCryptoModal={false}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL,
        component: (
          <WhitelistAddExternal
            wallet={wallet}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL]}
          />
        ),
      },
    ],
    [wallet, ledgerAccount, currentOptions, hide]
  );

  const selectedComponent = useMemo(
    () => sendCryptoFlow.find((item) => item.screen === currentScreen).component,
    [currentScreen, sendCryptoFlow]
  );

  return (
    <ModalRoot>
      <Modal>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{selectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};
export default WhitelistManagementModal;
WhitelistManagementModal.propTypes = {
  hide: PropTypes.func.isRequired,
  wallet: PropTypes.object.isRequired,
  ledgerAccount: PropTypes.object,
  onChangeWallet: PropTypes.func,
  wallets: PropTypes.any,
};
